"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = exports.delay = void 0;
const delay = (fn, time) => time
    ? new Promise((resolve) => {
        setTimeout(() => {
            fn().then((d) => resolve(d));
        }, time);
    })
    : Promise.resolve(fn());
exports.delay = delay;
const wait = (millis) => millis
    ? new Promise((resolve) => {
        setTimeout(resolve, millis);
    })
    : Promise.resolve();
exports.wait = wait;
